module.exports = __webpack_public_path__ + "static/media/luminousavenger.667aeb91.png";